import {Component, ElementRef, Input, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AnimationOptions} from 'ngx-lottie';
import {Location} from '@angular/common';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, takeUntil} from 'rxjs/operators';
import {PolicyService} from '../../../policy/services/policy.service';
import {QuotesService} from '../../../quotes/services/quotes.service';
import {PolicyQuery} from '../../../policy/state/policy.query';
import {UserStore} from '../../../authentication/state/user.store';
import {environment} from '../../../../../environments/environment';
import {slideInLeftOnEnterAnimation, slideInRightOnEnterAnimation, slideOutLeftOnLeaveAnimation} from 'angular-animations';

declare var accounting: any;
declare var $: any;
declare var noUiSlider: any;
declare var wNumb: any;
@Component({
    selector: 'app-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.scss'],
    animations: [
        slideInLeftOnEnterAnimation(),
        slideInRightOnEnterAnimation({ delay: 1000 }),
        slideOutLeftOnLeaveAnimation()
    ],
    standalone: false
})
export class QuestionComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  radioSelected: any;
  @Input() question: any;
  @Input() item: any;
  @Input() session_id!: string;
  slideOut:boolean=false;
  slideIn:boolean=false;
  private customStepper$ = new Subject<number>();

  private geoCoder: any;
  lottieOptions: AnimationOptions = {
    path: 'assets/everything-insure-loader.json',
  };
  policy:any;
  accounting_:any;
  latitude: number = 0;
  longitude: number = 0;
  person:any;
  @ViewChild('search')
  public searchElementRef!: ElementRef;
  marker:any=[];
  zoom = 12;
  map = false;
  subCategory:boolean=false;
  quotes:any=[];
  category:any=[];
  header:string='';
  center!: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    //mapTypeId: 'hybrid',
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    maxZoom: 15,
    minZoom: 8,
  }

  selectDropdownValue: string = '';

  constructor(
    private policyQuery: PolicyQuery,
    private policiesService: PolicyService,
    private quotesService: QuotesService,
    private ngZone: NgZone,
    private location: Location,
    private userStore: UserStore,
  ) {
    this.person = this.userStore.getValue();
    //console.log(this.person)
    this.quotesService.getQuoteLinks().
      pipe(takeUntil(this.unsubscribe$))
      .subscribe(result => {
        this.quotes = result;
        //console.log(this.quotes)
      },
        err => {
          //console.log(err)
        });
  }
  setCategory(category: any) {
    this.category = category;
    if (this.getSubCategory().length>0){
      //$('.layout__main').removeClass('in').addClass('out');
      $('.layout__main').removeClass('in back-in').addClass('out');
      setTimeout(() => {
        $('.layout__main').removeClass('out').addClass('in');
        this.subCategory = true;
        this.header = "Which section of <strong>"+this.category.header+"</strong> category would you like cover on?";
      }, 1000);
    }
  }
  getCategories(): any {
    return this.quotes.filter((quote: { level: number }) => quote.level === 1);
  }
  getSubCategory(): any {
    return this.quotes.filter((quote: { category_id: number, level: number; }) => quote.level === 2 && quote.category_id === this.category.category_id);
  }
  setStep(step: number, question: any) {
    //console.log(this.question)
    const newStep = Number(question.answer) + step;

    if (Number(question.val_min) <= newStep && Number(question.val_max) >= newStep) {
      question.answer = newStep;
      // saveAnswer is called in a debouncing subscription (executed below in the subject) in ngAfterViewInit.
      this.customStepper$.next(newStep)
    }
  }

  ngOnInit(): void {
    //window['angularComponentReference'] = { component: this, zone: this.ngZone, loadAngularFunction: () => this.saveAnswer(), };
    accounting.settings = {
      currency: {
        symbol: 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    }
    this.accounting_ = accounting;
    this.header = 'Hi '+this.person.first_name+', please select the <strong>insurance category</strong> you would like to get a quote on';
    //console.log(this.question,this.item,this.session_id)
    // if (this.question.question_id == 575) {
    //   this.question.val_max = 100000;
    //   this.question.val_min = 0;
    // }

  }
  getQuestions(q:any): void {
    //$('.layout__main').removeClass('in').addClass('out');
    $('.layout__main').removeClass('in back-in').addClass('out');
    setTimeout(() => {
      $('.layout__main').removeClass('out').addClass('in');
      this.question = { question_copy: "Which section of <strong>"+this.category.header+"</strong> category would you like cover on?", question_id: 1 };
    }, 1000);
  }
  getNextQuestions(q:any): void {
    $('.layout__main').removeClass('in back-in').addClass('out');
    setTimeout(() => {
      $('.layout__main').removeClass('out').addClass('in');
    }, 1000);
  }
  backToPreviousQuestion(q:any): void{
    $('.layout__main').removeClass('in back-in').addClass('back-out');
    setTimeout(() => {
      $('.layout__main').removeClass('out back-out').addClass('back-in');
    }, 1000);
  }
  ngOnDestroy(): void {
    if (this.customStepper$) {
      this.customStepper$.complete();
    }
  }
  trackByFn(index: number, option: any) {
    return index;
  }
  ngAfterViewInit(): void {
    //setTimeout(() => {
      this.slideIn = true;
    //}, 10);
  //Wait a bit for all the stuff to load then trigger js scripts, is there a better way?
    //setTimeout( ()=> {
    this.customStepper$.pipe(
      debounceTime(2000),
      distinctUntilChanged()
    ).subscribe((value: number) => {
      this.question.answer = value;
      this.saveAnswer();
    });

      const selectId = `#dropdown-${this.question.index}`
      $(selectId).selectmenu({
        change: (_event: any, data: any) => {
          this.selectDropdownValue = data?.item?.value;
          this.question.answer = this.selectDropdownValue;
          this.saveAnswer();
        }
      });

       $.each($(".multiselect"), (i: any, c: any) => {
         if (c.checked && $(c).attr("data-answer") == "None of the above") {
           var $siblingCtrls = $(c)
             .closest('.custom-input--checkbox')
             .siblings('.custom-input--checkbox')
             .find('input[type="checkbox"]');
           $siblingCtrls.prop('disabled', true)
           //console.log(c)
         }
       })
       // initCustomStep();
     //}, 100);
    try {
      if (this.question.question_type_id == 3) {
        this.googleMap();
      }
    }
    catch (e) { }
    if (this.question.question_type_id==7 && this.question.question_id==576){
      if (this.question.options!=""){
        $.each(JSON.parse(this.question.options),(i:number,o:any)=>{
          $("#radioBoxes").append(`
            <label class="custom-input custom-input--radio custom-input--pill">
            <input value="${o.answer}" type="radio" (click)="checkRadio('${o.answer}')" name="radio-${this.question.question_id}[]"/>
            <span class="custom-input__indi"></span>
            <span class="custom-input__label">${o.answer}</span>
        </label>
          `)
        })
      }

     }

     if (this.question.question_type_id==49 && this.question.answer.indexOf("None of the above")>=0){
      $.each($(".multiselect"),(i:number,el:any)=>{
        el.checked = false;
        $(el).prop('disabled', true);
        if (el.value=="None of the above") el.checked = true;
      })
     }
  }
  googleMap():void{
    this.geoCoder = new google.maps.Geocoder;
    this.geoCoder.geocode({ 'address': this.question.answer }, (results: { geometry: { location: any; }; }[], status: string) => {
      if (status === 'OK') {
        //console.log(status);
        this.ngZone.run(() => {
          this.map = true;
          $(".spinner").hide();
          this.latitude = results[0].geometry.location.lat();
          this.longitude = results[0].geometry.location.lng();
          this.center = {
            lat: this.latitude,
            lng: this.longitude,
          }
          this.marker = {
            position: {
              lat: this.latitude,
              lng: this.longitude,
            },
            options: { animation: google.maps.Animation.DROP },
          }
        })

      }
    });
    let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();

        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.zoom = 12;
        this.marker = {
          position: {
            lat: this.latitude,
            lng: this.longitude,
          },
          options: { animation: google.maps.Animation.DROP },
        }
        this.center = {
          lat: this.latitude,
          lng: this.longitude,
        }
        this.center = {
          lat: this.latitude,
          lng: this.longitude,
        }
      });
    });
  }
  checkRadio(answer:string): void{
    this.question.answer = answer;
    this.saveAnswer();
  }
  checkAllrisk():void{
    let category = $("#category").val();
    let description = $("#description").val();
    let amount = $("#amount").val();
    this.question.answer = category+"|"+this.stripCurrency(amount)+"|"+description;
    this.saveAnswer();
  }
  checkMultiSelect(): void{ //None of the above should disbaled the rest of the options
    let answers="";
    $.each($(".multiselect"),(i:number,el:any)=>{
      if (el.checked){
        if (el.value == "None of the above") {
          var $siblingCtrls = $(this)
            .closest('.custom-input--checkbox')
            .siblings('.custom-input--checkbox')
            .find('input[type="checkbox"]');
          $siblingCtrls.prop('disabled', true);
          answers = el.value;
        }
        else{
          answers+=el.value+"|";
        }

      }
      else{
        if (el.value == "None of the above") {
          var $siblingCtrls = $(el)
            .closest('.custom-input--checkbox')
            .siblings('.custom-input--checkbox')
            .find('input[type="checkbox"]');
          $siblingCtrls.prop('disabled', false);
          //answers = answers.replace("None of the above","");
        }
      }

    })
    if (answers.slice(-1)=="|"){
      this.question.answer = answers.slice(0,-1);
    }
    else{
      this.question.answer = answers
    }

    //console.log(this.question)
    if (this.question.answer!=""){
      this.saveAnswer();
    }
  }
  stripCurrency(text: string): string {
    try {
      return text.replace(/ /g, '').replace('R', '');
    }
    catch (e) {
      return text;
    }
  }
  checkDisabledQuestions(i:number): boolean{
    var arr = Array<number>();
    //List of questions that can't be changed
    arr = [47,50,71,73,84,268,519,523,566,508];
    if (arr.indexOf(i)>=0)
    return true;
    else return false;
  }
  getButtonOptions(): any{
    if (this.question.options!=""){
    try{
      ////console.log(JSON.parse(this.question.options))
      return JSON.parse(this.question.options);
    }
    catch(e){
      return this.question.options;
    }
  }


  }
  getOptions(): any{

    if (this.question.options!=""){
      ////console.log(JSON.parse(this.question.options))
      return JSON.parse(this.question.options);
    }

    else return [];
  }

  saveSliderValue(sliderData: any) {
    ////console.log('slider amount: ', sliderData?.sliderValue);
    this.question.answer = this.stripCurrency(sliderData?.sliderValue);
    //console.log(this.question);
    this.saveAnswer();
    // this.saveAnswer here after getting slider value? <=== leaving this up to you Sam, not sure if anything else needs
    // to be done
  }

  saveAnswer(): void{
    var answer = this.question.answer;
    // if (this.question.question_type_id==78 || this.question.question_type_id==79){
    //   answer = answer.replace("R","").replace(/ /g,""); //Tripe out formats
    // }
    $(".spinner").show();
    this.policiesService.saveAnswer(this.session_id,this.question.question_id,this.question.class_id,this.question.item_id,answer,0).
    pipe(takeUntil(this.unsubscribe$))
    .subscribe(result => {
      this.policiesService.updatePolicy(this.session_id,1).
      pipe(takeUntil(this.unsubscribe$))
      .subscribe(response => {
        //console.log(response);
        $("#oldPrice").show();
        $(".spinner").hide();
      },
      err => {
       //console.log(err);
       $(".spinner").hide();
      });
    },
    err => {
     //console.log(err);
     $(".spinner").hide();
    });
  }
  getDescriptionIndex(text:string,index:number): string{
    var t = text.split('|');
    return t[index];
  }
  backToCategories(): void {
    //this.location.back();
    $('.layout__main').removeClass('in back-in').addClass('back-out');
    setTimeout(() => {
      $('.layout__main').removeClass('out back-out').addClass('back-in');
      this.subCategory = false;
      this.header = 'Hi '+this.person.first_name+', please select the <strong>insurance category</strong> you would like to get a quote on';
    }, 1000);
  }
  redirectToAcquisition(quote:any):void{
    //console.log(quote)
    this.quotesService.createQuote(this.session_id,quote.category_id,quote.group_id,this.person.person_id,'0',0)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(result => {
        if (result[0].quote_id){
          window.location.href= environment.cssURL+'pages/questions.aspx?flowid='+quote.flow_id+'&categoryid='+quote.category_id+'&referer=central&groupid='+quote.group_id+'&session_id='+this.session_id;
        }

      },
        err => {
          //console.log('err: ', err);

        });

  }
}

